import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnInit,
	inject,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PdfModalComponent } from '@components/pdf-modal/pdf-modal.component';
import { ICON } from '@core/util/icon';
import { MatterDocumentType, MatterFile } from '@models/matter-file';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterUploadedFilesDispatch } from '@state/matter/uploaded-files/matter-uploaded-files.dispatch';
import { MatterUploadedFilesSelectors } from '@state/matter/uploaded-files/matter-uploaded-files.selectors';
import { Observable } from 'rxjs';
import { ManualTitleInsuranceUploadFileComponent } from '../../manual/upload-file-modal/upload-file-modal.component';
import {
	MatterFormViewerModalComponent,
	MatterFormViewerModalData,
} from '@components/matter-form-viewer/matter-form-viewer-modal/matter-form-viewer-modal.component';
import { PDFFormType } from '@models/matter-form-data';
import { MatterMortgagesState } from '@state/matter/matter_mortgages';
import { MatterMortgage, MatterMortgagePriority } from '@models/mortgage';
import { SelectedMatterFormsDispatch } from '@state/global/forms/selected-matter-forms.dispatch';
import { TestHooks } from './title-insurance-documents.hooks';
import { DrawerService } from 'src/app/ui/drawer/drawer.service';

@Component({
	selector: 'app-title-insurance-documents',
	templateUrl: './title-insurance-documents.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TitleInsuranceDocumentsComponent implements OnInit {
	testHooks = TestHooks;
	public TLFileType = MatterDocumentType.TITLE_INSURANCE;
	public ICON = ICON;

	@Input() type: 'default' | 'dropzone' = 'default';
	@Input() disabled = false;
	@Input() showCommercialForm = false;

	@SelectSnapshot(SelectedMatter.id) matterId: string;
	@Select(MatterUploadedFilesSelectors.getAllTitleInsuranceFiles)
	documents$: Observable<MatterFile[]>;
	@SelectSnapshot(SelectedMatter.titleInsuranceSelectedForm)
	selectedForm: PDFFormType;
	@SelectSnapshot(MatterMortgagesState.getAllMortgages)
	mortgages: MatterMortgage[];

	drawerService = inject(DrawerService);

	constructor(
		private dialog: MatDialog,
		private matterUploadedFilesDispatch: MatterUploadedFilesDispatch,
		private selectedMatterFormsDispatch: SelectedMatterFormsDispatch,
	) {}

	ngOnInit(): void {}

	openUploadModal(): void {
		this.dialog.open(ManualTitleInsuranceUploadFileComponent);
	}

	openDocument(data: MatterFile): void {
		this.drawerService.openDrawer(PdfModalComponent, {
			data: {
				googleSrcUrl: data.url,
				fileName: data.name,
				fileType: data.fileType,
			},
			title: data.name,
			noStyle: true,
		});
	}

	removeDocument(doc: MatterFile): void {
		this.matterUploadedFilesDispatch.Delete(doc.id);
	}

	openForm(): void {
		const data: MatterFormViewerModalData = {
			formId: this.selectedForm,
			mortgageId: this.mortgages.find(
				(m) => m.priority === MatterMortgagePriority.PRIORITY_1,
			)?.id,
		};

		this.selectedMatterFormsDispatch.SelectForm(this.selectedForm);

		this.dialog.open(MatterFormViewerModalComponent, {
			data,
			height: '95vh',
			maxWidth: '900px',
			width: '90%',
		});
	}
}
